import type { ContentInfo } from '@norlys-a-s/norlys-play-kmm';

import { mapNpvrInfo, type NpvrInfoData } from './getContentInfo';
import { kmm } from './kmm';

export type GetContentInfoAssetParams = {
  sid?: number;
  eventId?: number;
  mediaId?: number;
};

export interface ContentInfoAssetResponse {
  title: string;
  description: string;
  episodeNumber: number;
  episodeTitle: string;
  seasonNumber: number;
  readableAirTimeOrRecordingTime?: string;
  npvrInfo?: NpvrInfoData;
  expireTime?: number;
  infoBlock?: {
    duration: number;
    year: number;
    providerName: string;
    startTime?: number;
  };
}

const mapContentInfoForAsset = (contentInfo: ContentInfo): ContentInfoAssetResponse => {
  const npvrInfo = mapNpvrInfo(contentInfo.npvrInfo);
  const isRecording = Boolean(npvrInfo?.customerRecording || npvrInfo?.isSeriesRecording);

  return {
    title: contentInfo.title ?? '',
    description: contentInfo.description ?? '',
    episodeNumber: contentInfo.episodeNumber ?? 0,
    episodeTitle: contentInfo.episodeTitle ?? '',
    seasonNumber: contentInfo.seasonNumber ?? 0,
    readableAirTimeOrRecordingTime: contentInfo.readableAirTimeOrRecordingTime ?? undefined,
    npvrInfo,
    expireTime:
      (isRecording ? npvrInfo?.expireAt : undefined) ||
      contentInfo.infoBlock?.expireTimeEpochSeconds ||
      undefined,
    infoBlock: contentInfo.infoBlock
      ? {
          duration: contentInfo.infoBlock.durationSeconds ?? 0,
          year: contentInfo.infoBlock.year ?? 0,
          providerName: contentInfo.infoBlock.providerName ?? '',
          startTime: contentInfo.infoBlock.startTimeEpochSeconds ?? undefined
        }
      : undefined
  };
};

export const getContentInfoForAsset = async (
  payload: GetContentInfoAssetParams
): Promise<ContentInfoAssetResponse> => {
  const contentInfo = await kmm(
    (repo) => repo.getContentInfoForAsset(payload.sid, payload.eventId, payload.mediaId),
    false // this is a custom handled error with placeholder text, so we don't want to handle it generally
  );

  return mapContentInfoForAsset(contentInfo);
};

export default getContentInfoForAsset;
